<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_10720_2465)">
    <path d="M3.54761 15.1905V4.35718H12.2143V15.1905" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 15.5L13.7619 15.5" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.14813 7.45239H6.76718" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.93372 7.45264H9.55276" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.14801 9.92883H6.76706" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.93372 9.92883H9.55276" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.33362 15.1907V12.405H9.42886V15.1907" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.4762 4.04762V2.5H7.57143V4.04762" :stroke="color" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_10720_2465">
    <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
    </defs>
</svg>
</template>

<script>
export default {
    name: 'CompanyIcon',
    props: {
        size: {
            type: String,
            default: '24'
        },
        color: {
            type: String,
            default: '#727d94'
        },
    }
}
</script>
